import React, { useState } from "react";
import { toast } from "sonner";
import { FileDown, Printer, Loader2 } from "lucide-react";
import { downloadDoc, openDocPrint, apiErr } from "@/lib/api";

// docs: [{ label, path, filename }]
export function DocButtons({ docs, testidPrefix = "doc" }) {
  const [busy, setBusy] = useState("");
  const run = async (d, mode) => {
    setBusy(d.path + mode);
    try {
      if (mode === "print") await openDocPrint(d.path);
      else await downloadDoc(d.path, d.filename);
    } catch (e) { toast.error(apiErr(e, "Could not generate document.")); }
    finally { setBusy(""); }
  };
  return (
    <div className="grid sm:grid-cols-2 gap-2">
      {docs.map((d) => (
        <div key={d.path} className="flex items-center gap-1 bg-black/20 border border-white/10 rounded-md px-3 py-2">
          <span className="text-sm flex-1 truncate">{d.label}</span>
          <button onClick={() => run(d, "download")} disabled={!!busy} title="Download PDF"
            data-testid={`${testidPrefix}-download-${d.key}`} className="text-gold hover:text-gold/70 p-1">
            {busy === d.path + "download" ? <Loader2 size={15} className="animate-spin" /> : <FileDown size={15} />}
          </button>
          <button onClick={() => run(d, "print")} disabled={!!busy} title="Print view"
            data-testid={`${testidPrefix}-print-${d.key}`} className="text-muted-foreground hover:text-pool p-1">
            {busy === d.path + "print" ? <Loader2 size={15} className="animate-spin" /> : <Printer size={15} />}
          </button>
        </div>
      ))}
    </div>
  );
}

export default DocButtons;
